module.exports = __webpack_public_path__ + "img/00046.ce349d67.webp";